import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormWarningAlert } from 'components/reusables/formWarningAlert'

export const InactiveCourseMonitoringAlert: React.FC = () => {
  const { t } = useTranslation()

  return (
    <FormWarningAlert
      message={t('monitoring.course.inactiveCourseMonitoringBanner')}
    />
  )
}
